import RollOverCreditIcon from '../../../assets/icons/RollOverCreditIcon.svg?react';
import ALaCarteIcon from '../../../assets/icons/ALaCarteIcon.svg?react';
import FailedCaseIcon from '../../../assets/icons/FailedCaseIcon.svg?react';
import SdCardAlertIcon from '../../../assets/icons/SdCardAlertIcon.svg?react';
import Constants from "../../../Constants";

import CompanyStatCard from "../components/CompanyStatCard";
import CaseVolumeByCustomerPie from "../components/CaseVolumeByCustomerPie";
import CompaniesModal from "../components/CompaniesModal";
import BarStatCard from "../components/BarStatCard";
import LLMCostByCustomer from "../components/LLMCostByCustomer";
import CompanyFilters from "../components/CompanyFilters";
import XButton from "../../../components/common/XButton";
import CompaniesTable from "../components/CompaniesTable";
import CaseCountGraph from "../../admin/dashboard/components/CaseCountGraph";
import CompanyYTD from "../components/CompanyYTD";
import TooltipWrapper from "../../../components/ui-control/TooltipWrapper";
import { useSuperDashboardContext } from "./context/SuperDashboardContext";
import { dashboardListClasses, dashboardTitleClasses } from "../../../components/common/dashboardClasses";
import { statsGridClasses, chartStatsGridClasses, llmStatsGridClasses } from "../../../components/common/dashboardGridClasses";
import SuperAdminPageWrapper from "../components/SuperAdminPageWrapper";
import { COMPANY_MODAL_KEYS } from "../../../utils/enum";

const SuperDashboard = () => {
    const {
        downloadDashboardCsvFile,
        isLoading,
        openModal,
        openModalByKey,
        closeModal,
        activeCompanies,
        inactiveCompanies,
        badRecordsData,
        isSubscriptionLoading,
        rollOverCreditAnalytics,
        alaCarteCreditAnalytics,
        failedCasesData,
        failedCasesTableData,
        creditedCompanies,
        companiesCostData,
        companiesData,
        statCards,
        companyChatSessions
    } = useSuperDashboardContext();

    return (
        <SuperAdminPageWrapper>
            <div className={`container ${dashboardListClasses}`}>
                <div className="flex items-center gap-2 mb-6">
                    <h1 className={dashboardTitleClasses}>Dashboard</h1>
                    <CompanyFilters />
                    <TooltipWrapper showTooltip={true} title={"Download CSV file"}>
                        <div>
                            <XButton
                                variant="close"
                                className="p-0! text-sm"
                                onClick={downloadDashboardCsvFile}
                            >
                                <i className="fas fa-download"></i>
                            </XButton>
                        </div>
                    </TooltipWrapper>
                </div>
                <div className="mb-6">
                    <div className={`${statsGridClasses} mb-6`}>
                        {statCards.map((card, index) => (
                            <CompanyStatCard
                                key={index}
                                icon={card.icon}
                                title={card.title}
                                value={card.value}
                                isLoading={card.isLoading}
                                onClick={() => openModalByKey(card.modal)}
                            />
                        ))}
                    </div>
                    <div className={`${chartStatsGridClasses} mb-6`}>
                        <CompaniesTable />
                        <CompanyYTD />
                    </div>
                    <div className={`${statsGridClasses} mb-6`}>
                        <BarStatCard
                            title="Most Rollover Credits"
                            icon={<RollOverCreditIcon />}
                            data={rollOverCreditAnalytics}
                            colors={Constants.BarStatColorConstants.ROLLOVER}
                            cardIndex={0}
                            isLoading={isSubscriptionLoading}
                            onClick={() => openModalByKey(COMPANY_MODAL_KEYS.ROLLOVER_CREDITS)}
                        />
                        <BarStatCard
                            title="Most À La Carte Credits"
                            icon={<ALaCarteIcon />}
                            data={alaCarteCreditAnalytics}
                            colors={Constants.BarStatColorConstants.ALACARTE}
                            cardIndex={1}
                            isLoading={isSubscriptionLoading}
                            onClick={() => openModalByKey(COMPANY_MODAL_KEYS.ALACARTE_CREDITS)}
                        />
                        <BarStatCard
                            title="Most Failed Cases"
                            icon={<FailedCaseIcon />}
                            colors={Constants.BarStatColorConstants.FAILED_RECORDS}
                            cardIndex={2}
                            data={failedCasesData}
                        />
                        <BarStatCard
                            title="Most Failed Records"
                            icon={<SdCardAlertIcon />}
                            data={badRecordsData}
                            colors={Constants.BarStatColorConstants.FAILED_RECORDS}
                            cardIndex={3}
                        />
                    </div>
                    <div className={`${chartStatsGridClasses} mb-6`}>
                        <CaseCountGraph />
                        <CaseVolumeByCustomerPie />
                    </div>
                    <div className={llmStatsGridClasses}>
                        <LLMCostByCustomer />
                    </div>

                    <CompaniesModal
                        open={!!openModal}
                        configKey={openModal}
                        dashboardData={{
                            activeCompanies,
                            inactiveCompanies,
                            creditedCompanies,
                            failedCasesTableData,
                            companiesCostData,
                            companiesData,
                            companyChatSessions,
                            rollOverCreditAnalytics,
                            alaCarteCreditAnalytics
                        }}
                        isLoading={isLoading}
                        onClose={closeModal}
                    />
                </div>
            </div>
        </SuperAdminPageWrapper>
    );
};

export default SuperDashboard;
